import { P, lightTheme } from '../../styles';
import { Radio } from '../Radio/Radio';
import styled from 'styled-components';

const AdminRadioInputStyled = styled.div<{
  $checked?: boolean;
  $shadowDesign?: boolean;
  $disabled?: boolean;
}>`
  width: 100%;
  border: none;
  border-radius: 200px;
  line-height: 18px;
  height: 45px;
  appearance: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  color: ${({ $checked, theme }) =>
    $checked ? theme.primary : theme.darkGray};

  ${({ $shadowDesign, theme }) =>
    $shadowDesign &&
    `
    font-weight: 400;
    padding: 0 12px 0 24px;
    box-shadow: ${theme.shadows.shadow1};
    background: ${theme.white};
  `}

  @media (max-width: 800px) {
    font-size: 16px;
  }

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

export const AdminRadioInput = ({
  checked,
  onClick,
  shadowDesign,
  label,
  bold,
  disabled,
}: {
  checked: boolean;
  onClick?: () => void;
  shadowDesign?: boolean;
  label?: string;
  bold?: boolean;
  /** Greys the row out and ignores clicks. */
  disabled?: boolean;
}) => {
  return (
    <AdminRadioInputStyled
      $shadowDesign={shadowDesign}
      onClick={disabled ? undefined : onClick}
      $checked={checked}
      $disabled={disabled}
      role="checkbox"
      tabIndex={disabled ? -1 : 0}
      aria-checked={checked}
      aria-disabled={disabled}
      aria-label={label}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <P
        $m="0"
        $bold={bold}
        $color={disabled ? lightTheme.lightGray : checked && lightTheme.primary}
      >
        {label}
      </P>
      <Radio checked={checked} disabled={disabled} />
    </AdminRadioInputStyled>
  );
};
